module.exports = __webpack_public_path__ + "img/Event_2.6a43cc22.jpg";